import Vue from "vue";
import axios from 'axios'

const state = {
    isLoggedIn: false,
    claims: {},
};

const getters = {
}

const actions = {
    async loadUser({ commit }) {
        try {
            const response = await axios.get(window.envConfig.API_BASEURL + '/api/claims', { withCredentials: true });
            commit('setIsLoggedIn', true)
            commit('setClaims', response.data)
        }
        catch (error) {
            commit('setIsLoggedIn', false)
            commit('setClaims', {})
        }
    },
    async getCustomer({ commit }) {
        const response = await axios.get(window.envConfig.API_BASEURL + '/api/customer', { withCredentials: true });
        return response.data.customer
    },
};

const mutations = {
    setIsLoggedIn(state, isLoggedIn) {
        state.isLoggedIn = isLoggedIn
    },
    setClaims(state, claims) {
        state.claims = claims
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}